module.exports = __webpack_public_path__ + "static/img/img_release.0b738e9c.png";